import React, { useState } from "react"
import * as styles from "./Boxes.module.css"
import classNames from "classnames"
import useDeviceType from "../../../../hooks/useDeviceType"

type BoxesProps = {
  details: Array<{
    svg: any
    title?: string
    description: string
  }>
  simple?: boolean
}

const Boxes = ({ simple, details }: BoxesProps) => {
  const [open, setOpen] = useState(false)

  const openCards = () => {
    setOpen(preOpen => !preOpen)
  }

  const DeviceType = useDeviceType()

  return (
    <>
      {(DeviceType === "mobile" || DeviceType === "tablet") && (
        <div
          style={{
            height: open ? `${360 * details.length - 1}px` : `${360}px`,
          }}
        />
      )}

      {details.map(({ svg, title, description }, index) => (
        <div
          key={index}
          className={classNames(styles.box, {
            [styles.open]: open,
            [styles.simple]: simple,
          })}
          onClick={openCards}
          style={
            (DeviceType === "mobile" || DeviceType === "tablet") && open
              ? { top: `${360 * index + 60}px` }
              : undefined
          }
        >
          {simple && (
            <span className={styles.decorativeNumber}>{index + 1}</span>
          )}
          <div className={styles.svgCircle}>{svg}</div>
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      ))}
    </>
  )
}

export default Boxes
